import styled, { css } from "styled-components";

import { Grid, MenuItem, Select } from "@mui/material";

import Button from "src/components/core/Button";

import { device } from "src/styles/device";
import font from "src/styles/font";
import {
  Black,
  DarkGrey,
  Grey,
  GreyStroke,
  Primary,
  White01,
} from "src/styles/color";

export const Container = styled.div`
  width: 100%;
  max-width: 1240px;
  position: relative;
  padding: 20px 20px 40px;
  margin: 0 auto;
  /* background-color: ${White01}; */

  & > div > p {
    word-wrap: break-word;
  }

  @media ${device.tabletL} {
    padding: 20px 20px 36px;
  }
  @media ${device.mobileL} {
    padding: 16px 16px 24px;
  }
`;

export const SpanTitle = styled.div`
  color: ${({ color }) => (color ? color : Black)};
  font-size: ${font.size.md};
  font-weight: 600;
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : 0)};

  @media ${device.tabletL} {
    font-size: ${font.size.sm};
  }
`;

export const SpanSubTitle = styled.div`
  color: ${({ color }) => (color ? color : Black)};
  font-size: ${font.size.md};
  font-weight: 400;

  span {
    font-size: ${font.size.md};
    font-weight: 400;
  }

  @media ${device.tabletL} {
    font-size: ${font.size.sm};
  }
`;

export const WrapperHeaderFixed = styled.div`
  width: 100%;
  /* max-width: 1240px; */
  position: sticky;
  top: 0;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

export const HeaderFixed = styled.div`
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  @media ${device.tabletL} {
    padding: 8px 20px;
  }
`;

export const HeaderItem = styled.div`
  width: max-content;
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const DivBackground = styled.div`
  width: 100%;
  padding: 24px;
  background-color: #ffffff;
  /* box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2); */
  border-radius: 16px;
  /* margin: 16px 0; */

  @media ${device.tabletL} {
    padding: 16px;
  }
`;

export const StyledSelect = styled(Select)`
  border-radius: 16px;
  text-align: center;

  .MuiSelect-select {
    padding: 8px 16px;
  }
  &.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${DarkGrey};
  }
  .Mui-disabled,
  &.Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: ${GreyStroke};
  }

  @media ${device.tabletL} {
    .MuiSelect-select {
      padding: 8px 12px;
    }
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    line-height: 24px;
    min-height: 40px;
    padding: 8px 24px;
  }

  @media ${device.tabletL} {
    &.MuiMenuItem-root {
      padding: 8px 16px;
    }
  }
`;

export const SelectSpan = styled.span`
  font-size: ${font.size.sm};
  font-weight: 400;
  line-height: 24px;

  @media ${device.tabletL} {
    font-size: ${font.size.xs};
  }
`;

export const SpanSubHeader = styled.p`
  color: ${Black};
  font-size: ${font.size.sm};
  font-weight: 500;
  /* line-height: 24px; */
  margin-bottom: 8px;
  margin-top: 0;

  @media ${device.tabletL} {
    font-size: ${font.size.xs};
  }
`;

export const SpanContent = styled.div`
  min-height: 48px;
  color: ${Black};
  font-size: ${font.size.md};
  font-weight: 400;
  /* line-height: 24px; */
  margin: 0;
  background: ${White01};
  padding: 12px 16px;
  border-radius: 16px;
  border: 1px solid ${GreyStroke};

  > a {
    color: ${Black};
    font-size: ${font.size.md};
    font-weight: 400;
    text-decoration: underline;
  }

  @media ${device.tabletL} {
    padding: 8px 12px;
    font-size: ${font.size.sm};
    min-height: 40px;
  }
`;

export const DivProductTitle = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const WrapperProductList = styled.div`
  width: 100%;
  /* min-width: 500px; */
  overflow: hidden;
  overflow-x: auto;
`;

export const DivProductHeader = styled(Grid)`
  width: 100%;
  /* min-width: 1000px; */
  /* padding: 8px 12px; */
  background: #f3f1f2;
  align-items: center;

  @media ${device.tabletL} {
    min-width: 580px;
  }
`;

export const GridHeader = styled(Grid)`
  width: 100%;
  padding: 8px 12px;
  align-items: center;
`;

export const HeaderLabel = styled.div`
  color: ${Black};
  font-size: ${font.size.sm};
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  margin: auto;

  @media ${device.tabletL} {
    font-size: ${font.size.xs};
  }
`;

export const DivProduct = styled.div`
  width: 100%;
  /* min-width: 1000px; */

  @media ${device.tabletL} {
    min-width: 580px;
  }
`;

export const WrapperTextField = styled.div`
  width: 100%;

  /* read-only */
  .MuiInputBase-root.MuiOutlinedInput-root.Mui-readOnly {
    background-color: ${White01};
  }
  .MuiInputBase-root.MuiOutlinedInput-root.Mui-readOnly
    .MuiOutlinedInput-input {
    background: ${White01};
    border-radius: 16px;
  }
`;

export const WrapperProductCondition = styled(WrapperTextField)`
  margin-top: 4px;
`;

export const WrapperProduct = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* padding: 8px 0; */
  border-bottom: 1px solid #d9d9d9;
`;

export const WrapperProductDetail = styled.div`
  width: 100%;
  display: flex;
`;

export const WrapperProductImage = styled.div`
  width: 80px;
  min-width: 80px;
  height: 80px;
  margin: auto 0;
  padding: 8px;
  /* flex: 1; */

  @media ${device.tabletL} {
    margin-top: 12px;
  }
  @media ${device.mobileL} {
    margin: 0;
  }
`;

export const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;

  &:hover {
    opacity: 0.8;
  }

  @media ${device.tabletL} {
    border-radius: 8px;
  }
`;

export const ImgProduct = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 16px;

  @media ${device.tabletL} {
    border-radius: 8px;
  }
`;

export const WrapperDesc = styled.div`
  width: calc(100% - 80px);
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media ${device.tabletL} {
    width: calc(100% - 64px);
    padding: 8px;
  }
  @media ${device.mobileL} {
    width: calc(100% - 48px);
  }
`;

export const ProductName = styled.p`
  margin: 0;
  font-size: ${font.size.sm};
  font-weight: 400;
  color: ${Black};

  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;

  @media ${device.tabletL} {
    font-size: ${font.size.xs};
  }
`;

export const ProductSubDetail = styled.p`
  margin: 0;
  font-size: ${font.size.xs};
  font-weight: 400;
  color: ${DarkGrey};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${device.tabletL} {
    font-size: 0.625rem;
  }
`;

export const WrapperPriceField = styled.div`
  width: 100%;
  padding: 8px 12px;
  /* display: flex;
  justify-content: center; */
`;

export const PriceLabel = styled.p`
  font-size: ${font.size.sm};
  font-weight: 400;
  text-align: center;

  @media ${device.tabletL} {
    font-size: ${font.size.xs};
  }
`;

export const StyledButton = styled(Button)`
  /* &.MuiButtonBase-root {
    padding: 12px 16px;
    font-size: ${font.size.md};
  }

  @media ${device.tabletL} {
    &.MuiButtonBase-root {
      padding: 8px 12px;
      font-size: ${font.size.xs};
    }
  } */
  @media ${device.mobileL} {
    width: 50%;
    /* &.MuiButtonBase-root {
      padding: 8px 12px;
      font-size: ${font.size.xs};
    } */
  }
`;

export const WrapperCalOrder = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0;
  margin-top: 16px;
  gap: 8px;

  @media ${device.mobileL} {
    margin-top: 8px;
  }
`;

export const RowSumPrice = styled.div`
  margin-left: 0;
  margin-right: 0;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
`;

export const FocusRowSumPrice = styled(RowSumPrice)`
  margin-top: 16px;
  align-items: flex-end;

  @media ${device.mobileL} {
    margin-top: 8px;
  }
`;

export const Price = styled.p`
  margin: 0;
  color: ${(props) => (props.fontColor ? props.fontColor : Black)};
  font-size: ${font.size.md};
  font-weight: ${(props) => (props.bold ? 600 : 400)};
  text-align: ${(props) => (props.align ? props.align : "left")};

  ${({ desc, focus }) =>
    desc
      ? css`
          display: flex;
          flex-direction: column;

          span {
            font-size: ${font.size.xs};
            font-weight: 400;
            color: ${DarkGrey};
            /* text-decoration: underline;
            margin-left: 10px;
            cursor: pointer; */
          }
        `
      : focus
        ? css`
            span {
              font-size: ${font.size.xl};
              font-weight: 600;
              color: ${Primary};
            }
          `
        : css``}

  @media ${device.tablet} {
    font-size: ${font.size.sm};

    ${({ desc, focus }) =>
      desc
        ? css`
            span {
              font-size: ${font.size.xs};
            }
          `
        : focus
          ? css`
              span {
                font-size: ${font.size.lg};
              }
            `
          : css``}
  }
`;

export const DivPaymentContainer = styled.div`
  width: 100%;
  display: grid;
  align-items: flex-start;
  gap: 24px;
  grid-template-columns: ${({ single }) => (single ? "1fr" : "1fr auto 1fr")};

  @media ${device.tabletL} {
    gap: 16px;
    grid-template-columns: 1fr;
  }
`;

export const DivPaymentTitle = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SpanPaymentStatus = styled.div`
  color: ${Black};
  font-size: ${font.size.md};
  font-weight: 400;

  span {
    color: ${Grey};
    font-size: ${font.size.md};
    font-weight: 400;
  }

  @media ${device.tabletL} {
    font-size: ${font.size.sm};

    span {
      font-size: ${font.size.sm};
    }
  }
`;

export const RowDownloadDoc = styled.div`
  width: 100%;
  display: flex;
  flex-direction: ${({ col }) => (col ? "column" : "row")};
  justify-content: ${({ col }) => (col ? "center" : "space-around")};
  align-items: ${({ col }) => (col ? "initial" : "center")};
  /* margin-top: 20px;
  margin-bottom: 40px; */

  :last-child {
    margin-bottom: 0;
  }
`;

export const DownloadDocBox = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ single }) =>
    single ? "minmax(230px, calc(50% - 8px))" : "repeat(2, 1fr)"};
  align-items: center;
  gap: 16px;

  @media ${device.tabletL} {
    gap: 8px;
    grid-template-columns: ${({ single }) =>
      single ? "minmax(210px, calc(50% - 8px))" : "repeat(2, 1fr)"};
  }
  @media ${device.mobileL} {
    grid-template-columns: ${({ single }) =>
      single ? "minmax(160px, max-content)" : "repeat(2, 1fr)"};
  }
`;

export const WrapperAttachPayment = styled.div`
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const WrapperImgSlip = styled.div`
  width: 100%;
  max-width: 300px;
  height: auto;
`;

export const SpanPaymentType = styled.div`
  color: #252525;
  font-size: ${font.size.md};
  font-weight: ${({ paytype }) => (paytype ? 600 : 400)};
  text-align: ${({ paytype }) => (paytype ? "right" : "left")};
  max-width: 50%;
  flex: 0 0 50%;
  /* margin-bottom: 8px; */

  @media ${device.tabletL} {
    font-size: ${font.size.sm};
  }
`;

export const ImgSlip = styled.img`
  width: 100%;
  height: 100%;
  /* max-height: 300px; */
  object-fit: contain;
`;

export const WrapperTextNote = styled(WrapperTextField)`
  // margin-bottom: 16px;
  width: 100%;
  margin-top: 16px;

  .MuiInputBase-root.MuiOutlinedInput-root {
    padding: 12px 16px;
  }

  @media ${device.tabletL} {
    margin-top: 8px;

    .MuiInputBase-root.MuiOutlinedInput-root {
      padding: 8px 12px;
    }
  }
`;

// Maps
export const WrapperMapsContainer = styled.div`
  width: 100%;
  padding-top: calc(100% / (16 / 9));
  position: relative;

  @media ${device.tablet} {
    padding-top: calc(100% / (16 / 9));
  }
  @media ${device.mobileL} {
    padding-top: calc(100% / (8 / 10));
  }
`;

export const MapsContainer = styled.div`
  position: absolute;
  border: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 16px;
`;
